import { sendWS } from "@/plugins/websocket";
import Vue from "vue";

async function sleep(ms = 0) {
  return new Promise(r => setTimeout(r, ms));
}

interface Message {
  messageId: number;
  memberId: number;
  managerId?: number;
  content: string;
  createTime: Date;
  updateTime: Date;
}

interface Contact {
  messages: Array<Message>;
  hasMessages?: boolean;
  show?: boolean;
  open?: boolean;
  loading?: boolean;
  initialed?: boolean;
}

const contact = {
  namespaced: true,
  state: {
    messages: [],
    hasMessages: false,
    show: true,
    open: false,
    loading: true,
    initialed: false
  } as Contact,
  mutations: {
    setMessages(state: Contact, options: Contact) {
      Vue.set(state, "messages", options.messages);
      Vue.set(state, "count", options.hasMessages);
      Vue.set(state, "initialed", true);
    },
    setShow(state: Contact, isShow: boolean) {
      Vue.set(state, "show", isShow);
    },
    setOpen(state: Contact, isOpen: boolean) {
      Vue.set(state, "open", isOpen);
    },
    setLoading(state: Contact, loading: boolean) {
      Vue.set(state, "loading", loading);
    },
    toggleShow(state: Contact) {
      Vue.set(state, "show", !state.show);
    },
    toggleOpen(state: Contact) {
      Vue.set(state, "open", !state.open);
    },
    pushMessage(state: Contact, message: Message) {
      state.messages.unshift(message);
    },
    pushMessages(state: Contact, options: Contact) {
      state.messages = state.messages.concat(options.messages);
      Vue.set(state, "hasMessages", options.hasMessages);
    },
    clearMessage(state: Contact) {
      state.messages.length = 0;
      state.hasMessages = false;
      state.show = true;
      state.open = false;
      state.loading = true;
      state.initialed = false;
    }
  },
  actions: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async openContact(context: any) {
      context.commit("setShow", true);
      context.commit("setOpen", true);
      if (context.state.messages.length === 0) {
        context.commit("setLoading", true);
        const send = {
          Event: "initialMessage"
        };
        sendWS(send);
      }
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async initialMessage(context: any, options: Contact) {
      context.commit("setMessages", options);
      await sleep(100);
      context.commit("setLoading", false);
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async scroolMessage(context: any, options: Contact) {
      context.commit("pushMessages", options);
      await sleep(100);
      context.commit("setLoading", false);
    }
  }
};

export default contact;
